export const Types = {
  SUBMIT_COPY_PRIZE: 'SUBMIT_COPY_PRIZE',
  COPY_PRIZE_COMPLETE: 'COPY_PRIZE_COMPLETE',
  START_COPY_PRIZE: 'START_COPY_PRIZE',
  END_COPY_PRIZE: 'END_COPY_PRIZE',
  COPY_PRIZE_ERROR: 'COPY_PRIZE_ERROR'
};

export const submitCopyPrizeAction = (title, lang) => ({
  type: Types.SUBMIT_COPY_PRIZE,
  title,
  lang
});

export const copyPrizeCompleteAction = prizeId => ({
  type: Types.COPY_PRIZE_COMPLETE,
  prizeId
});

export const startCopyPrizeAction = copyPrizeId => ({
  type: Types.START_COPY_PRIZE,
  copyPrizeId // id of the prize to copy
});

export const endCopyPrizeAction = () => ({
  type: Types.END_COPY_PRIZE
});

export const copyPrizeErrorAction = error => ({
  type: Types.COPY_PRIZE_ERROR,
  error
});



// WEBPACK FOOTER //
// ./public/pages/PrizeCopy/actions.js